export enum KeyActionTypes {
    GET_REQUESTS = "[App Action][KEY] GET REQUESTS",
    GET_REQUESTS_SUCCESS = "[App Action][KEY] GET REQUESTS SUCCESS",
    GET_REQUESTS_FAIL = "[App Action][KEY] GET REQUESTS FAIL"
}
